module.exports = __webpack_public_path__ + "img/work_better5.32ef1125.png";